// // import React from 'react'

// // const LifeIndk = () => {
// //   return (
// //     <div>LifeIndk</div>
// //   )
// // }

// // export default LifeIndk


// import React, { useState, useEffect } from 'react';
// import './LifeIndk.css';

// const PCDL_APP_URL = "https://web.lwappstore.com/share/appId-7d63342107dd8e64b326708c075d9824";

// export default function LifeIndk() {
//   // Navigation & Scroll State
//   const [isScrolled, setIsScrolled] = useState(false);
//   const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
//   const [activeSection, setActiveSection] = useState('overview');

//   // Interactive Content State
//   const [activeFaq, setActiveFaq] = useState(null);

//   // Modal State
//   const [activeModal, setActiveModal] = useState(null); // 'app' | null

//   // Handle Navbar Scroll
//   useEffect(() => {
//     const handleScroll = () => {
//       if (window.scrollY > 40) {
//         setIsScrolled(true);
//       } else {
//         setIsScrolled(false);
//       }

//       // Scroll spy logic
//       const sections = ['overview', 'experience', 'gains', 'participate', 'certificate', 'faq'];
//       for (const section of sections) {
//         const el = document.getElementById(section);
//         if (el) {
//           const top = el.offsetTop - 120;
//           const height = el.offsetHeight;
//           if (window.scrollY >= top && window.scrollY < top + height) {
//             setActiveSection(section);
//             break;
//           }
//         }
//       }
//     };

//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   return (
//     <div className="app-container">
//       {/* Background Ambient Glows */}
//       <div className="bg-glow glow-1"></div>
//       <div className="bg-glow glow-2"></div>
//       <div className="bg-glow glow-3"></div>

//       {/* Navigation Bar */}
//       <header className={`navbar-container ${isScrolled ? 'scrolled' : ''}`}>
//         <nav className="navbar max-width">
//           <div className="logo-group">
//             <div className="logo-badge">STDL</div>
//             <div className="brand-text">
//               <span className="brand-title">Life in the Kingdom</span>
//               <span className="brand-sub">FOR STAFF</span>
//             </div>
//           </div>

//           <div className={`nav-links ${isMobileMenuOpen ? 'mobile-open' : ''}`}>
//             <a 
//               href="#overview" 
//               className={`nav-link ${activeSection === 'overview' ? 'active' : ''}`}
//               onClick={() => setIsMobileMenuOpen(false)}
//             >
//               Overview
//             </a>
//             <a 
//               href="#experience" 
//               className={`nav-link ${activeSection === 'experience' ? 'active' : ''}`}
//               onClick={() => setIsMobileMenuOpen(false)}
//             >
//               The 30-Day Experience
//             </a>
//             <a 
//               href="#gains" 
//               className={`nav-link ${activeSection === 'gains' ? 'active' : ''}`}
//               onClick={() => setIsMobileMenuOpen(false)}
//             >
//               What You'll Gain
//             </a>
//             <a 
//               href="#participate" 
//               className={`nav-link ${activeSection === 'participate' ? 'active' : ''}`}
//               onClick={() => setIsMobileMenuOpen(false)}
//             >
//               How to Participate
//             </a>
//             <a 
//               href="#certificate" 
//               className={`nav-link ${activeSection === 'certificate' ? 'active' : ''}`}
//               onClick={() => setIsMobileMenuOpen(false)}
//             >
//               Certification
//             </a>
//             <a 
//               href="#faq" 
//               className={`nav-link ${activeSection === 'faq' ? 'active' : ''}`}
//               onClick={() => setIsMobileMenuOpen(false)}
//             >
//               FAQ
//             </a>
//           </div>

//           <div className="nav-actions">
//             <a 
//               href={PCDL_APP_URL} 
//               target="_blank" 
//               rel="noreferrer" 
//               className="btn btn-primary btn-sm"
//             >
//               <i className="fa-solid fa-cloud-arrow-down"></i> Launch PCDL App v4.1
//             </a>
//             <button 
//               className="mobile-toggle" 
//               onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
//               aria-label="Toggle Mobile Navigation"
//             >
//               <i className={`fa-solid ${isMobileMenuOpen ? 'fa-xmark' : 'fa-bars'}`}></i>
//             </button>
//           </div>
//         </nav>
//       </header>

//       {/* Main Content */}
//       <main>
//         {/* HERO SECTION */}
//         <section id="overview" className="hero-section">
//           <div className="max-width grid-2 hero-grid">
//             <div className="hero-content">
//               <div className="badge-pill">
//                 <span className="pulse-dot"></span>
//                 30-Day National Orientation Programme
//               </div>
              
//               <h1 className="hero-title">
//                 This Journey Is <span className="text-gradient-gold">For You</span>
//               </h1>
              
//               <p className="hero-subtitle">
//                 You are not just part of an organization. <strong>You are a citizen of a Kingdom Nation.</strong> Discover your identity, responsibilities, and how to function, reign, and rule through the transformative teachings of <strong>Pastor Chris</strong>.
//               </p>

//               <div className="hero-metrics">
//                 <div className="metric-card">
//                   <span className="metric-value">30</span>
//                   <span className="metric-label">Days of Growth</span>
//                 </div>
//                 <div className="metric-divider"></div>
//                 <div className="metric-card">
//                   <span className="metric-value">6</span>
//                   <span className="metric-label">Daily Pillars</span>
//                 </div>
//                 <div className="metric-divider"></div>
//                 <div className="metric-card">
//                   <span className="metric-value">100%</span>
//                   <span className="metric-label">Transformation</span>
//                 </div>
//               </div>

//               <div className="hero-cta-group">
//                 <a 
//                   href={PCDL_APP_URL} 
//                   target="_blank" 
//                   rel="noreferrer" 
//                   className="btn btn-primary btn-lg"
//                 >
//                   <span>Launch PCDL App v4.1</span>
//                   <i className="fa-solid fa-arrow-right"></i>
//                 </a>
//               </div>

//               <div className="collaboration-tag margin-top-sm">
//                 <i className="fa-solid fa-shield-halved text-gold"></i>
//                 <span>Powered by <strong>Pastor Chris Digital Library</strong> in collaboration with <strong>CELF Online</strong></span>
//               </div>
//             </div>

//             <div className="hero-visual">
//               <div className="image-wrapper glass-card">
//                 <img src="/s.jpg" alt="Staff members participating in Life in the Kingdom" className="hero-image" />
//                 <div className="hero-overlay"></div>
                
//                 {/* Floating Glass Cards */}
//                 <div className="floating-card float-top-left glass-card">
//                   <div className="float-icon bg-gold-glow">
//                     <i className="fa-solid fa-crown"></i>
//                   </div>
//                   <div>
//                     <div className="float-title">Kingdom Identity</div>
//                     <div className="float-desc">Function & Reign</div>
//                   </div>
//                 </div>

//                 <div className="floating-card float-bottom-right glass-card">
//                   <div className="float-icon bg-purple-glow">
//                     <i className="fa-solid fa-award"></i>
//                   </div>
//                   <div>
//                     <div className="float-title">Certificate & Badge</div>
//                     <div className="float-desc">Earn Official Recognition</div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </section>

//         {/* THE 30-DAY EXPERIENCE SECTION */}
//         <section id="experience" className="section-padding bg-dark-accent">
//           <div className="max-width">
//             <div className="section-header center">
//               <span className="section-badge">Daily Growth Blueprint</span>
//               <h2 className="section-title">What You Will <span className="text-gradient">Experience</span></h2>
//               <p className="section-subtitle">
//                 For 30 days, engage with a rich structured daily curriculum designed to help you understand your identity and apply Kingdom principles to your everyday life.
//               </p>
//             </div>

//             {/* 6 Pillars Grid */}
//             <div className="pillars-grid">
//               <div className="pillar-card glass-card">
//                 <div className="pillar-icon-box">
//                   <i className="fa-solid fa-circle-play"></i>
//                 </div>
//                 <h3>Daily Video</h3>
//                 <p>Inspiring visual teachings by Pastor Chris delivering deep Kingdom insights and realities.</p>
//                 <div className="pillar-tag">Visual Learning</div>
//               </div>

//               <div className="pillar-card glass-card">
//                 <div className="pillar-icon-box">
//                   <i className="fa-solid fa-headphones"></i>
//                 </div>
//                 <h3>Audio Messages</h3>
//                 <p>High-quality audio content accessible on-the-go for continuous meditation and learning.</p>
//                 <div className="pillar-tag">On-The-Go</div>
//               </div>

//               <div className="pillar-card glass-card">
//                 <div className="pillar-icon-box">
//                   <i className="fa-solid fa-book-open"></i>
//                 </div>
//                 <h3>Curated Reading</h3>
//                 <p>Key scripture excerpts, study notes, and excerpts for foundational understanding.</p>
//                 <div className="pillar-tag">Deep Study</div>
//               </div>

//               <div className="pillar-card glass-card">
//                 <div className="pillar-icon-box">
//                   <i className="fa-solid fa-list-check"></i>
//                 </div>
//                 <h3>Interactive Quiz</h3>
//                 <p>Evaluate your comprehension daily and reinforce foundational Kingdom concepts.</p>
//                 <div className="pillar-tag">Assessment</div>
//               </div>

//               <div className="pillar-card glass-card">
//                 <div className="pillar-icon-box">
//                   <i className="fa-solid fa-lightbulb"></i>
//                 </div>
//                 <h3>Personal Reflection</h3>
//                 <p>Guided prompts to help internalize the daily revelations into your mindset and walk.</p>
//                 <div className="pillar-tag">Mindset Shift</div>
//               </div>

//               <div className="pillar-card glass-card">
//                 <div className="pillar-icon-box">
//                   <i className="fa-solid fa-list-dots"></i>
//                 </div>
//                 <h3>Practical Assignments</h3>
//                 <p>Actionable exercises to actively practice Kingdom reign and rule in your workstation.</p>
//                 <div className="pillar-tag">Real Application</div>
//               </div>
//             </div>
//           </div>
//         </section>

//         {/* WHAT YOU WILL GAIN SECTION */}
//         <section id="gains" className="section-padding">
//           <div className="max-width">
//             <div className="section-header center">
//               <span className="section-badge">Empowerment & Transformation</span>
//               <h2 className="section-title">What You Will <span className="text-gradient-gold">Gain</span></h2>
//               <p className="section-subtitle">
//                 Step out of routine orientation into true Kingdom authorization and alignment.
//               </p>
//             </div>

//             <div className="gains-grid">
//               <div className="gain-card glass-card">
//                 <div className="gain-number">01</div>
//                 <div className="gain-content">
//                   <h3>Your Kingdom Identity</h3>
//                   <p>Understand who you truly are as a citizen of a Kingdom Nation, moving beyond corporate titles to divine purpose.</p>
//                 </div>
//               </div>

//               <div className="gain-card glass-card">
//                 <div className="gain-number">02</div>
//                 <div className="gain-content">
//                   <h3>Place & Responsibilities</h3>
//                   <p>Gain absolute clarity on your specific divine assignment, role, and accountability within the Kingdom structure.</p>
//                 </div>
//               </div>

//               <div className="gain-card glass-card">
//                 <div className="gain-number">03</div>
//                 <div className="gain-content">
//                   <h3>Kingdom Culture & Vision</h3>
//                   <p>Embrace the high standards, mindset, ethics, and heavenly culture required for impactful Kingdom service.</p>
//                 </div>
//               </div>

//               <div className="gain-card glass-card">
//                 <div className="gain-number">04</div>
//                 <div className="gain-content">
//                   <h3>Reign & Rule in Everything</h3>
//                   <p>Receive practical spiritual keys to exercise authority, dominate challenges, and reign in all affairs of life.</p>
//                 </div>
//               </div>

//               <div className="gain-card glass-card full-width-gain">
//                 <div className="gain-number">05</div>
//                 <div className="gain-content">
//                   <h3>Kingdom Realities by Pastor Chris</h3>
//                   <p>Unlock profound revelation teachings straight from Pastor Chris, establishing a firm foundation for lifelong victory and spiritual leadership.</p>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </section>

//         {/* HOW CAN I PARTICIPATE SECTION */}
//         <section id="participate" className="section-padding bg-dark-accent">
//           <div className="max-width">
//             <div className="section-header center">
//               <span className="section-badge">4 Simple Steps</span>
//               <h2 className="section-title">How Can I <span className="text-gradient">Participate?</span></h2>
//               <p className="section-subtitle">
//                 Follow these simple steps to join the 30-Day National Orientation Programme today.
//               </p>
//             </div>

//             <div className="grid-2 participate-container">
//               {/* Left Timeline */}
//               <div className="steps-timeline">
//                 <div className="step-item">
//                   <div className="step-badge">01</div>
//                   <div className="step-info">
//                     <h3>Update PCDL App to v4.1</h3>
//                     <p>Ensure your <strong>Pastor Chris Digital Library App</strong> is updated to the latest <strong>version 4.1</strong> on iOS or Android via the Loveworld AppStore.</p>
//                     <a 
//                       href={PCDL_APP_URL} 
//                       target="_blank" 
//                       rel="noreferrer" 
//                       className="btn btn-sm btn-outline margin-top-sm"
//                     >
//                       <i className="fa-solid fa-store text-gold"></i> Open Loveworld AppStore
//                     </a>
//                   </div>
//                 </div>

//                 <div className="step-item">
//                   <div className="step-badge">02</div>
//                   <div className="step-info">
//                     <h3>Click "Life in the Kingdom" Banner</h3>
//                     <p>Open the updated PCDL app and tap directly on the prominent <strong>Life in the Kingdom</strong> orientation banner on your home screen.</p>
//                   </div>
//                 </div>

//                 <div className="step-item">
//                   <div className="step-badge">03</div>
//                   <div className="step-info">
//                     <h3>Access Course in App</h3>
//                     <p>Gain full access by purchasing the course or using your assigned code directly within the PCDL App.</p>
//                     <div className="step-code-actions margin-top-sm">
//                       <span className="badge-tag"><i className="fa-solid fa-coins text-gold"></i> 2 ESPEES Course</span>
//                       <span className="badge-tag"><i className="fa-solid fa-gift"></i> Gift Course</span>
//                       <span className="badge-tag"><i className="fa-solid fa-key"></i> Zonal Access</span>
//                     </div>
//                   </div>
//                 </div>

//                 <div className="step-item">
//                   <div className="step-badge">04</div>
//                   <div className="step-info">
//                     <h3>Watch, Study & Participate Daily</h3>
//                     <p>Engage with each daily episode during your <strong>Chapel services</strong> and <strong>Personal study times</strong> to complete all reflection and quiz modules.</p>
//                   </div>
//                 </div>
//               </div>

//               {/* Right Media Showcase - Male Banner */}
//               <div className="banner-media-showcase">
//                 <div className="media-display glass-card">
//                   <img 
//                     src="/S1.png" 
//                     alt="How can I participate step-by-step banner" 
//                     className="banner-preview-img" 
//                   />
//                   <div className="media-caption">
//                     <i className="fa-solid fa-circle-info"></i> Official Participation Guide Graphic
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </section>

//         {/* CERTIFICATION SECTION */}
//         <section id="certificate" className="section-padding">
//           <div className="max-width grid-2 cert-grid">
//             {/* Left Column: Female Staff Banner Image */}
//             <div className="cert-visual-image">
//               <div className="media-display glass-card">
//                 <img 
//                   src="/S2.png" 
//                   alt="Staff member participating in Life in the Kingdom" 
//                   className="banner-preview-img" 
//                 />
//                 <div className="media-caption">
//                   <i className="fa-solid fa-crown text-gold"></i> Official Staff Orientation Recognition
//                 </div>
//               </div>
//             </div>

//             {/* Right Column: Certification Details */}
//             <div className="cert-content">
//               <span className="section-badge">Reward of Excellence</span>
//               <h2 className="section-title">Complete the <span className="text-gradient-gold">Journey</span></h2>
              
//               <div className="cert-highlight-box margin-top-md" style={{ marginLeft: 0, marginRight: 0 }}>
//                 <div className="cert-icon-large text-gold">
//                   <i className="fa-solid fa-certificate"></i>
//                 </div>
//                 <h3>CERTIFICATE OF COMPLETION</h3>
//                 <p className="cert-award-text">
//                   This is proudly awarded for successfully mastering the 30-Day Orientation Programme:
//                 </p>
//                 <div className="cert-course-title">Life in the Kingdom for Staff</div>
//               </div>

//               <div className="cert-perks-row margin-top-lg" style={{ justifyContent: 'flex-start' }}>
//                 <div className="perk-pill">
//                   <i className="fa-solid fa-certificate text-gold"></i>
//                   <span>Official Certificate</span>
//                 </div>
//                 <div className="perk-pill">
//                   <i className="fa-solid fa-award text-gold"></i>
//                   <span>Digital Badge</span>
//                 </div>
//                 <div className="perk-pill">
//                   <i className="fa-solid fa-star text-gold"></i>
//                   <span>Special Recognition</span>
//                 </div>
//               </div>

//               <a 
//                 href={PCDL_APP_URL} 
//                 target="_blank" 
//                 rel="noreferrer" 
//                 className="btn btn-primary btn-lg margin-top-lg"
//               >
//                 <span>Launch PCDL App v4.1</span>
//                 <i className="fa-solid fa-arrow-right"></i>
//               </a>
//             </div>
//           </div>
//         </section>

//         {/* FAQ SECTION */}
//         <section id="faq" className="section-padding bg-dark-accent">
//           <div className="max-width">
//             <div className="section-header center">
//               <span className="section-badge">Got Questions?</span>
//               <h2 className="section-title">Frequently Asked <span className="text-gradient">Questions</span></h2>
//             </div>

//             <div className="faq-accordion max-width-sm">
//               {[
//                 {
//                   id: 1,
//                   q: "Who is this 30-Day Orientation Programme for?",
//                   a: "This programme is specifically designed for all staff members to align with Kingdom culture, understand their identity, and learn how to function and reign in their daily workstation and lives."
//                 },
//                 {
//                   id: 2,
//                   q: "Which version of the PCDL App is required?",
//                   a: "You must update your Pastor Chris Digital Library (PCDL) App to the latest version 4.1 to access the Life in the Kingdom banner and features."
//                 },
//                 {
//                   id: 3,
//                   q: "How do I get access in the PCDL App?",
//                   a: "You can obtain access through your zonal coordinator, or directly purchase the course for 2 ESPEES (or receive a gifted course) right inside the PCDL App."
//                 },
//                 {
//                   id: 4,
//                   q: "When should I complete the daily episodes?",
//                   a: "Episodes can be watched during designated Chapel services and personal study times. Consistency is key to achieving maximum impact and eligibility for the certificate!"
//                 },
//                 {
//                   id: 5,
//                   q: "How do I receive my Certificate and Digital Badge?",
//                   a: "Upon completing all 30 daily modules, quizzes, and reflection assignments, your Certificate of Completion and Digital Badge will be unlocked in your PCDL App profile."
//                 }
//               ].map((faq) => (
//                 <div key={faq.id} className={`faq-item glass-card ${activeFaq === faq.id ? 'active' : ''}`}>
//                   <button 
//                     className="faq-question" 
//                     onClick={() => setActiveFaq(activeFaq === faq.id ? null : faq.id)}
//                   >
//                     <span>{faq.q}</span>
//                     <i className="fa-solid fa-chevron-down faq-icon"></i>
//                   </button>
//                   <div className="faq-answer">
//                     <p>{faq.a}</p>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </section>

//         {/* FINAL CTA BANNER */}
//         <section className="cta-banner-section section-padding">
//           <div className="max-width">
//             <div className="cta-card glass-card text-center">
//               <span className="badge-pill gold-pill">Ready to Transform Your Kingdom Perspective?</span>
//               <h2>Start Your 30-Day Journey Today</h2>
//               <p>Launch the PCDL App v4.1 directly from the Loveworld AppStore to start Life in the Kingdom and reign in everything concerning you.</p>
//               <div className="cta-btn-group">
//                 <a 
//                   href={PCDL_APP_URL} 
//                   target="_blank" 
//                   rel="noreferrer" 
//                   className="btn btn-primary btn-lg"
//                 >
//                   <i className="fa-solid fa-store"></i> Launch via Loveworld AppStore
//                 </a>
//               </div>
//             </div>
//           </div>
//         </section>
//       </main>

//       {/* FOOTER */}
//       <footer className="site-footer">
//         <div className="max-width footer-grid">
//           <div className="footer-brand">
//             <div className="logo-group">
//               <div className="logo-badge">STDL</div>
//               <span className="brand-title">Life in the Kingdom</span>
//             </div>
//             <p>30-Day National Orientation Programme for Staff through the teachings of Pastor Chris.</p>
//             <div className="footer-collab">
//               <span>Pastor Chris Digital Library x CELF Online</span>
//             </div>
//           </div>

//           <div className="footer-links">
//             <h4>Quick Navigation</h4>
//             <ul>
//               <li><a href="#overview">Overview</a></li>
//               <li><a href="#experience">The 30-Day Experience</a></li>
//               <li><a href="#gains">What You'll Gain</a></li>
//               <li><a href="#participate">How to Participate</a></li>
//               <li><a href="#certificate">Certification</a></li>
//             </ul>
//           </div>

//           <div className="footer-contact">
//             <h4>Official App Store</h4>
//             <p>Ensure your PCDL App is updated to version 4.1</p>
//             <div className="app-badges">
//               <a href={PCDL_APP_URL} target="_blank" rel="noreferrer" className="app-store-btn">
//                 <i className="fa-solid fa-store text-gold"></i>
//                 <div>
//                   <small>Download on</small>
//                   <strong>Loveworld AppStore</strong>
//                 </div>
//               </a>
//             </div>
//           </div>
//         </div>

//         <div className="footer-bottom max-width">
//           <p>&copy; 2026 Life in the Kingdom for Staff. All rights reserved.</p>
//           <p>Designed for Kingdom Citizens & Staff orientation.</p>
//         </div>
//       </footer>

//       {/* MODAL: PCDL APP V4.1 GUIDE */}
//       <div 
//         className={`modal-overlay ${activeModal === 'app' ? 'active' : ''}`}
//         onClick={(e) => e.target.classList.contains('modal-overlay') && setActiveModal(null)}
//       >
//         <div className="modal-card glass-card">
//           <button className="modal-close" onClick={() => setActiveModal(null)}>
//             <i className="fa-solid fa-xmark"></i>
//           </button>
//           <div className="modal-header">
//             <div className="modal-icon bg-purple-glow">
//               <i className="fa-solid fa-mobile-screen-button"></i>
//             </div>
//             <h3>Pastor Chris Digital Library App v4.1</h3>
//             <p>Get the latest PCDL app on Loveworld AppStore</p>
//           </div>
          
//           <div className="app-steps-guide">
//             <div className="guide-step">
//               <span className="guide-num">1</span>
//               <span>Open the official <strong>Loveworld AppStore</strong>.</span>
//             </div>
//             <div className="guide-step">
//               <span className="guide-num">2</span>
//               <span>Install or Update <strong>Pastor Chris Digital Library</strong> to version 4.1.</span>
//             </div>
//             <div className="guide-step">
//               <span className="guide-num">3</span>
//               <span>Launch PCDL App & Click the <strong>Life in the Kingdom</strong> banner on the home screen.</span>
//             </div>
//           </div>

//           <div className="modal-btn-row margin-top-md">
//             <a href={PCDL_APP_URL} target="_blank" rel="noreferrer" className="btn btn-primary btn-full">
//               <i className="fa-solid fa-store"></i> Open Loveworld AppStore Link
//             </a>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }


//Go Back


import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom'; // <-- IMPORT ADDED
import './LifeIndk.css';

const PCDL_APP_URL = "https://web.lwappstore.com/share/appId-7d63342107dd8e64b326708c075d9824";

export default function LifeIndk() {
  const navigate = useNavigate(); // <-- NAVIGATE INITIALIZED

  // Navigation & Scroll State
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState('overview');

  // Interactive Content State
  const [activeFaq, setActiveFaq] = useState(null);

  // Modal State
  const [activeModal, setActiveModal] = useState(null); // 'app' | null

  // Handle Navbar Scroll
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 40) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }

      // Scroll spy logic
      const sections = ['overview', 'experience', 'gains', 'participate', 'certificate', 'faq'];
      for (const section of sections) {
        const el = document.getElementById(section);
        if (el) {
          const top = el.offsetTop - 120;
          const height = el.offsetHeight;
          if (window.scrollY >= top && window.scrollY < top + height) {
            setActiveSection(section);
            break;
          }
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="app-container">
      {/* Background Ambient Glows */}
      <div className="bg-glow glow-1"></div>
      <div className="bg-glow glow-2"></div>
      <div className="bg-glow glow-3"></div>

      {/* Navigation Bar */}
      <header className={`navbar-container ${isScrolled ? 'scrolled' : ''}`}>
        <nav className="navbar max-width">
          <div className="logo-group">
            <div className="logo-badge">STDL</div>
            <div className="brand-text">
              <span className="brand-title">Life in the Kingdom</span>
              <span className="brand-sub">FOR STAFF</span>
            </div>
          </div>

          <div className={`nav-links ${isMobileMenuOpen ? 'mobile-open' : ''}`}>
            <a 
              href="#overview" 
              className={`nav-link ${activeSection === 'overview' ? 'active' : ''}`}
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Overview
            </a>
            <a 
              href="#experience" 
              className={`nav-link ${activeSection === 'experience' ? 'active' : ''}`}
              onClick={() => setIsMobileMenuOpen(false)}
            >
              The 30-Day Experience
            </a>
            <a 
              href="#gains" 
              className={`nav-link ${activeSection === 'gains' ? 'active' : ''}`}
              onClick={() => setIsMobileMenuOpen(false)}
            >
              What You'll Gain
            </a>
            <a 
              href="#participate" 
              className={`nav-link ${activeSection === 'participate' ? 'active' : ''}`}
              onClick={() => setIsMobileMenuOpen(false)}
            >
              How to Participate
            </a>
            <a 
              href="#certificate" 
              className={`nav-link ${activeSection === 'certificate' ? 'active' : ''}`}
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Certification
            </a>
            <a 
              href="#faq" 
              className={`nav-link ${activeSection === 'faq' ? 'active' : ''}`}
              onClick={() => setIsMobileMenuOpen(false)}
            >
              FAQ
            </a>
          </div>

          <div className="nav-actions">
            <a 
              href={PCDL_APP_URL} 
              target="_blank" 
              rel="noreferrer" 
              className="btn btn-primary btn-sm"
            >
              <i className="fa-solid fa-cloud-arrow-down"></i> Start Now
            </a>
            <button 
              className="mobile-toggle" 
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              aria-label="Toggle Mobile Navigation"
            >
              <i className={`fa-solid ${isMobileMenuOpen ? 'fa-xmark' : 'fa-bars'}`}></i>
            </button>
          </div>
        </nav>
                <section className="back-navigation-section max-width">
          <button className="btn-go-back" onClick={() => navigate('/')}>
            <i className="fa-solid fa-arrow-left"></i> Return
          </button>
        </section>
      </header>

      {/* Main Content */}
      <main>
        {/* HERO SECTION */}
        <section id="overview" className="hero-section">
          <div className="max-width grid-2 hero-grid">
            <div className="hero-content">
            
              <div className="badge-pill">
                <span className="pulse-dot"></span>
                30-Day National Orientation Programme
              </div>
              
              <h1 className="hero-title">
                This Journey Is <span className="text-gradient-gold">For You</span>
              </h1>
              
              <p className="hero-subtitle">
                You are not just part of an organization. <strong>You are a citizen of a Kingdom Nation.</strong> Discover your identity, responsibilities, and how to function, reign, and rule through the transformative teachings of <strong>Pastor Chris</strong>.
              </p>

              <div className="hero-metrics">
                <div className="metric-card">
                  <span className="metric-value">30</span>
                  <span className="metric-label">Days of Growth</span>
                </div>
                <div className="metric-divider"></div>
                <div className="metric-card">
                  <span className="metric-value">6</span>
                  <span className="metric-label">Daily Pillars</span>
                </div>
                <div className="metric-divider"></div>
                <div className="metric-card">
                  <span className="metric-value">100%</span>
                  <span className="metric-label">Transformation</span>
                </div>
              </div>

              <div className="hero-cta-group">
                <a 
                  href={PCDL_APP_URL} 
                  target="_blank" 
                  rel="noreferrer" 
                  className="btn btn-primary btn-lg"
                >
                  <span>Start Now</span>
                  <i className="fa-solid fa-arrow-right"></i>
                </a>
              </div>

              <div className="collaboration-tag margin-top-sm">
                <i className="fa-solid fa-shield-halved text-gold"></i>
                <span>Powered by <strong>Pastor Chris Digital Library</strong> in collaboration with <strong>CELF Online</strong></span>
              </div>
            </div>

            <div className="hero-visual">
              <div className="image-wrapper glass-card">
                <img src="/s.jpg" alt="Staff members participating in Life in the Kingdom" className="hero-image" />
                <div className="hero-overlay"></div>
                
                {/* Floating Glass Cards */}
                <div className="floating-card float-top-left glass-card">
                  <div className="float-icon bg-gold-glow">
                    <i className="fa-solid fa-crown"></i>
                  </div>
                  <div>
                    <div className="float-title">Kingdom Identity</div>
                    <div className="float-desc">Function & Reign</div>
                  </div>
                </div>

                <div className="floating-card float-bottom-right glass-card">
                  <div className="float-icon bg-purple-glow">
                    <i className="fa-solid fa-award"></i>
                  </div>
                  <div>
                    <div className="float-title">Certificate & Badge</div>
                    <div className="float-desc">Earn Official Recognition</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* THE 30-DAY EXPERIENCE SECTION */}
        <section id="experience" className="section-padding bg-dark-accent">
          <div className="max-width">
            <div className="section-header center">
              <span className="section-badge">Daily Growth Blueprint</span>
              <h2 className="section-title">What You Will <span className="text-gradient">Experience</span></h2>
              <p className="section-subtitle">
                For 30 days, engage with a rich structured daily curriculum designed to help you understand your identity and apply Kingdom principles to your everyday life.
              </p>
            </div>

            {/* 6 Pillars Grid */}
            <div className="pillars-grid">
              <div className="pillar-card glass-card">
                <div className="pillar-icon-box">
                  <i className="fa-solid fa-circle-play"></i>
                </div>
                <h3>Daily Video</h3>
                <p>Inspiring visual teachings by Pastor Chris delivering deep Kingdom insights and realities.</p>
                <div className="pillar-tag">Visual Learning</div>
              </div>

              <div className="pillar-card glass-card">
                <div className="pillar-icon-box">
                  <i className="fa-solid fa-headphones"></i>
                </div>
                <h3>Audio Messages</h3>
                <p>High-quality audio content accessible on-the-go for continuous meditation and learning.</p>
                <div className="pillar-tag">On-The-Go</div>
              </div>

              <div className="pillar-card glass-card">
                <div className="pillar-icon-box">
                  <i className="fa-solid fa-book-open"></i>
                </div>
                <h3>Curated Reading</h3>
                <p>Key scripture excerpts, study notes, and excerpts for foundational understanding.</p>
                <div className="pillar-tag">Deep Study</div>
              </div>

              <div className="pillar-card glass-card">
                <div className="pillar-icon-box">
                  <i className="fa-solid fa-list-check"></i>
                </div>
                <h3>Interactive Quiz</h3>
                <p>Evaluate your comprehension daily and reinforce foundational Kingdom concepts.</p>
                <div className="pillar-tag">Assessment</div>
              </div>

              <div className="pillar-card glass-card">
                <div className="pillar-icon-box">
                  <i className="fa-solid fa-lightbulb"></i>
                </div>
                <h3>Personal Reflection</h3>
                <p>Guided prompts to help internalize the daily revelations into your mindset and walk.</p>
                <div className="pillar-tag">Mindset Shift</div>
              </div>

              <div className="pillar-card glass-card">
                <div className="pillar-icon-box">
                  <i className="fa-solid fa-list-dots"></i>
                </div>
                <h3>Practical Assignments</h3>
                <p>Actionable exercises to actively practice Kingdom reign and rule in your workstation.</p>
                <div className="pillar-tag">Real Application</div>
              </div>
            </div>
          </div>
        </section>

        {/* WHAT YOU WILL GAIN SECTION */}
        <section id="gains" className="section-padding">
          <div className="max-width">
            <div className="section-header center">
              <span className="section-badge">Empowerment & Transformation</span>
              <h2 className="section-title">What You Will <span className="text-gradient-gold">Gain</span></h2>
              <p className="section-subtitle">
                Step out of routine orientation into true Kingdom authorization and alignment.
              </p>
            </div>

            <div className="gains-grid">
              <div className="gain-card glass-card">
                <div className="gain-number">01</div>
                <div className="gain-content">
                  <h3>Your Kingdom Identity</h3>
                  <p>Understand who you truly are as a citizen of a Kingdom Nation, moving beyond corporate titles to divine purpose.</p>
                </div>
              </div>

              <div className="gain-card glass-card">
                <div className="gain-number">02</div>
                <div className="gain-content">
                  <h3>Place & Responsibilities</h3>
                  <p>Gain absolute clarity on your specific divine assignment, role, and accountability within the Kingdom structure.</p>
                </div>
              </div>

              <div className="gain-card glass-card">
                <div className="gain-number">03</div>
                <div className="gain-content">
                  <h3>Kingdom Culture & Vision</h3>
                  <p>Embrace the high standards, mindset, ethics, and heavenly culture required for impactful Kingdom service.</p>
                </div>
              </div>

              <div className="gain-card glass-card">
                <div className="gain-number">04</div>
                <div className="gain-content">
                  <h3>Reign & Rule in Everything</h3>
                  <p>Receive practical spiritual keys to exercise authority, dominate challenges, and reign in all affairs of life.</p>
                </div>
              </div>

              <div className="gain-card glass-card full-width-gain">
                <div className="gain-number">05</div>
                <div className="gain-content">
                  <h3>Kingdom Realities by Pastor Chris</h3>
                  <p>Unlock profound revelation teachings straight from Pastor Chris, establishing a firm foundation for lifelong victory and spiritual leadership.</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* HOW CAN I PARTICIPATE SECTION */}
        <section id="participate" className="section-padding bg-dark-accent">
          <div className="max-width">
            <div className="section-header center">
              <span className="section-badge">4 Simple Steps</span>
              <h2 className="section-title">How Can I <span className="text-gradient">Participate?</span></h2>
              <p className="section-subtitle">
                Follow these simple steps to join the 30-Day National Orientation Programme today.
              </p>
            </div>

            <div className="grid-2 participate-container">
              {/* Left Timeline */}
              <div className="steps-timeline">
                <div className="step-item">
                  <div className="step-badge">01</div>
                  <div className="step-info">
                    <h3>Update PCDL App to v4.1</h3>
                    <p>Ensure your <strong>Pastor Chris Digital Library App</strong> is updated to the latest <strong>version 4.1</strong> on iOS or Android via the Loveworld AppStore.</p>
                    <a 
                      href={PCDL_APP_URL} 
                      target="_blank" 
                      rel="noreferrer" 
                      className="btn btn-sm btn-outline margin-top-sm"
                    >
                      <i className="fa-solid fa-store text-gold"></i> Open Loveworld AppStore
                    </a>
                  </div>
                </div>

                <div className="step-item">
                  <div className="step-badge">02</div>
                  <div className="step-info">
                    <h3>Click "Life in the Kingdom" Banner</h3>
                    <p>Open the updated PCDL app and tap directly on the prominent <strong>Life in the Kingdom</strong> orientation banner on your home screen.</p>
                  </div>
                </div>

                <div className="step-item">
                  <div className="step-badge">03</div>
                  <div className="step-info">
                    <h3>Access Course in App</h3>
                    <p>Gain full access by purchasing the course or using your assigned code directly within the PCDL App.</p>
                    <div className="step-code-actions margin-top-sm">
                      <span className="badge-tag"><i className="fa-solid fa-coins text-gold"></i> 2 ESPEES Course</span>
                      <span className="badge-tag"><i className="fa-solid fa-gift"></i> Gift Course</span>
                      <span className="badge-tag"><i className="fa-solid fa-key"></i> Zonal Access</span>
                    </div>
                  </div>
                </div>

                <div className="step-item">
                  <div className="step-badge">04</div>
                  <div className="step-info">
                    <h3>Watch, Study & Participate Daily</h3>
                    <p>Engage with each daily episode during your <strong>Chapel services</strong> and <strong>Personal study times</strong> to complete all reflection and quiz modules.</p>
                  </div>
                </div>
              </div>

              {/* Right Media Showcase - Male Banner */}
              <div className="banner-media-showcase">
                <div className="media-display glass-card">
                  <img 
                    src="/S1.png" 
                    alt="How can I participate step-by-step banner" 
                    className="banner-preview-img" 
                  />
                  <div className="media-caption">
                    <i className="fa-solid fa-circle-info"></i> Official Participation Guide Graphic
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* CERTIFICATION SECTION */}
        <section id="certificate" className="section-padding">
          <div className="max-width grid-2 cert-grid">
            {/* Left Column: Female Staff Banner Image */}
            <div className="cert-visual-image">
              <div className="media-display glass-card">
                <img 
                  src="/S2.png" 
                  alt="Staff member participating in Life in the Kingdom" 
                  className="banner-preview-img" 
                />
                <div className="media-caption">
                  <i className="fa-solid fa-crown text-gold"></i> Official Staff Orientation Recognition
                </div>
              </div>
            </div>

            {/* Right Column: Certification Details */}
            <div className="cert-content">
              <span className="section-badge">Reward of Excellence</span>
              <h2 className="section-title">Complete the <span className="text-gradient-gold">Journey</span></h2>
              
              <div className="cert-highlight-box margin-top-md" style={{ marginLeft: 0, marginRight: 0 }}>
                <div className="cert-icon-large text-gold">
                  <i className="fa-solid fa-certificate"></i>
                </div>
                <h3>CERTIFICATE OF COMPLETION</h3>
                <p className="cert-award-text">
                  This is proudly awarded for successfully mastering the 30-Day Orientation Programme:
                </p>
                <div className="cert-course-title">Life in the Kingdom for Staff</div>
              </div>

              <div className="cert-perks-row margin-top-lg" style={{ justifyContent: 'flex-start' }}>
                <div className="perk-pill">
                  <i className="fa-solid fa-certificate text-gold"></i>
                  <span>Official Certificate</span>
                </div>
                <div className="perk-pill">
                  <i className="fa-solid fa-award text-gold"></i>
                  <span>Digital Badge</span>
                </div>
                <div className="perk-pill">
                  <i className="fa-solid fa-star text-gold"></i>
                  <span>Special Recognition</span>
                </div>
              </div>

              <a 
                href={PCDL_APP_URL} 
                target="_blank" 
                rel="noreferrer" 
                className="btn btn-primary btn-lg margin-top-lg"
              >
                <span>Launch PCDL App v4.1</span>
                <i className="fa-solid fa-arrow-right"></i>
              </a>
            </div>
          </div>
        </section>

        {/* FAQ SECTION */}
        <section id="faq" className="section-padding bg-dark-accent">
          <div className="max-width">
            <div className="section-header center">
              <span className="section-badge">Got Questions?</span>
              <h2 className="section-title">Frequently Asked <span className="text-gradient">Questions</span></h2>
            </div>

            <div className="faq-accordion max-width-sm">
              {[
                {
                  id: 1,
                  q: "Who is this 30-Day Orientation Programme for?",
                  a: "This programme is specifically designed for all staff members to align with Kingdom culture, understand their identity, and learn how to function and reign in their daily workstation and lives."
                },
                {
                  id: 2,
                  q: "Which version of the PCDL App is required?",
                  a: "You must update your Pastor Chris Digital Library (PCDL) App to the latest version 4.1 to access the Life in the Kingdom banner and features."
                },
                {
                  id: 3,
                  q: "How do I get access in the PCDL App?",
                  a: "You can obtain access through your zonal coordinator, or directly purchase the course for 2 ESPEES (or receive a gifted course) right inside the PCDL App."
                },
                {
                  id: 4,
                  q: "When should I complete the daily episodes?",
                  a: "Episodes can be watched during designated Chapel services and personal study times. Consistency is key to achieving maximum impact and eligibility for the certificate!"
                },
                {
                  id: 5,
                  q: "How do I receive my Certificate and Digital Badge?",
                  a: "Upon completing all 30 daily modules, quizzes, and reflection assignments, your Certificate of Completion and Digital Badge will be unlocked in your PCDL App profile."
                }
              ].map((faq) => (
                <div key={faq.id} className={`faq-item glass-card ${activeFaq === faq.id ? 'active' : ''}`}>
                  <button 
                    className="faq-question" 
                    onClick={() => setActiveFaq(activeFaq === faq.id ? null : faq.id)}
                  >
                    <span>{faq.q}</span>
                    <i className="fa-solid fa-chevron-down faq-icon"></i>
                  </button>
                  <div className="faq-answer">
                    <p>{faq.a}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* FINAL CTA BANNER */}
        <section className="cta-banner-section section-padding">
          <div className="max-width">
            <div className="cta-card glass-card text-center">
              <span className="badge-pill gold-pill">Ready to Transform Your Kingdom Perspective?</span>
              <h2>Start Your 30-Day Journey Today</h2>
              <p>Launch the PCDL App v4.1 directly from the Loveworld AppStore to start Life in the Kingdom and reign in everything concerning you.</p>
              <div className="cta-btn-group">
                <a 
                  href={PCDL_APP_URL} 
                  target="_blank" 
                  rel="noreferrer" 
                  className="btn btn-primary btn-lg"
                >
                  <i className="fa-solid fa-store"></i> Launch via Loveworld AppStore
                </a>
              </div>
            </div>
          </div>
        </section>

        {/* =========================================
            NEW: RETURN BACK BUTTON SECTION 
            ========================================= */}

      </main>

      {/* FOOTER */}
      <footer className="site-footer">
        <div className="max-width footer-grid">
          <div className="footer-brand">
            <div className="logo-group">
              <div className="logo-badge">STDL</div>
              <span className="brand-title">Life in the Kingdom</span>
            </div>
            <p>30-Day National Orientation Programme for Staff through the teachings of Pastor Chris.</p>
            <div className="footer-collab">
              <span>Pastor Chris Digital Library x CELF Online</span>
            </div>
          </div>

          <div className="footer-links">
            <h4>Quick Navigation</h4>
            <ul>
              <li><a href="#overview">Overview</a></li>
              <li><a href="#experience">The 30-Day Experience</a></li>
              <li><a href="#gains">What You'll Gain</a></li>
              <li><a href="#participate">How to Participate</a></li>
              <li><a href="#certificate">Certification</a></li>
            </ul>
          </div>

          <div className="footer-contact">
            <h4>Official App Store</h4>
            <p>Ensure your PCDL App is updated to version 4.1</p>
            <div className="app-badges">
              <a href={PCDL_APP_URL} target="_blank" rel="noreferrer" className="app-store-btn">
                <i className="fa-solid fa-store text-gold"></i>
                <div>
                  <small>Download on</small>
                  <strong>Loveworld AppStore</strong>
                </div>
              </a>
            </div>
          </div>
        </div>

        <div className="footer-bottom max-width">
          <p>&copy; 2026 Life in the Kingdom for Staff. All rights reserved.</p>
          <p>Designed for Kingdom Citizens & Staff orientation.</p>
        </div>
      </footer>

      {/* MODAL: PCDL APP V4.1 GUIDE */}
      <div 
        className={`modal-overlay ${activeModal === 'app' ? 'active' : ''}`}
        onClick={(e) => e.target.classList.contains('modal-overlay') && setActiveModal(null)}
      >
        <div className="modal-card glass-card">
          <button className="modal-close" onClick={() => setActiveModal(null)}>
            <i className="fa-solid fa-xmark"></i>
          </button>
          <div className="modal-header">
            <div className="modal-icon bg-purple-glow">
              <i className="fa-solid fa-mobile-screen-button"></i>
            </div>
            <h3>Pastor Chris Digital Library App v4.1</h3>
            <p>Get the latest PCDL app on Loveworld AppStore</p>
          </div>
          
          <div className="app-steps-guide">
            <div className="guide-step">
              <span className="guide-num">1</span>
              <span>Open the official <strong>Loveworld AppStore</strong>.</span>
            </div>
            <div className="guide-step">
              <span className="guide-num">2</span>
              <span>Install or Update <strong>Pastor Chris Digital Library</strong> to version 4.1.</span>
            </div>
            <div className="guide-step">
              <span className="guide-num">3</span>
              <span>Launch PCDL App & Click the <strong>Life in the Kingdom</strong> banner on the home screen.</span>
            </div>
          </div>

          <div className="modal-btn-row margin-top-md">
            <a href={PCDL_APP_URL} target="_blank" rel="noreferrer" className="btn btn-primary btn-full">
              <i className="fa-solid fa-store"></i> Open Loveworld AppStore Link
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
